import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "item", "container", "noResults", "resultsCount", "count"]

  search() {
    const searchTerm = this.inputTarget.value.toLowerCase().trim()
    let matchedItems = []

    // Clear previous highlights
    this.itemTargets.forEach(item => {
      item.classList.remove('ring-2', 'ring-green-500', 'bg-green-50', 'opacity-40')
      item.classList.add('bg-gray-50')
    })

    if (searchTerm === '') {
      // Reset to normal state
      this.noResultsTarget.classList.add('hidden')
      this.resultsCountTarget.classList.add('hidden')

      // Scroll to top when search is cleared
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
      return
    }

    // Find and highlight matches
    this.itemTargets.forEach(item => {
      const question = item.dataset.question

      if (question.includes(searchTerm)) {
        // Highlight matched items
        item.classList.remove('bg-gray-50')
        item.classList.add('ring-2', 'ring-green-500', 'bg-green-50')
        matchedItems.push(item)
      } else {
        // Dim non-matched items
        item.classList.add('opacity-40')
      }
    })

    // Show results count or no results message
    if (matchedItems.length === 0) {
      this.noResultsTarget.classList.remove('hidden')
      this.resultsCountTarget.classList.add('hidden')
    } else {
      this.noResultsTarget.classList.add('hidden')
      this.resultsCountTarget.classList.remove('hidden')
      this.countTarget.textContent = matchedItems.length

      // Scroll to first match with smooth behavior
      matchedItems[0].scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      })
    }
  }
}
